<mat-toolbar class="header">
    <mat-toolbar-row>
        <span class="logo">
            <a class="navbar-brand" href="/#/inicio">
                <img src="assets/images/generico/logo-login.png" width="30%" style="margin-top: -34px;">
            </a>
        </span>
        <span class="example-spacer"></span>
        <div *ngIf="!identity || !token"></div>
        <div *ngIf="identity || token">
            <button mat-button style="color: black !important" (click)="openPerfil()">
                {{identity?.nombres + ' '+ identity?.apellidoP + ' ' + identity?.apellidoM}}
            </button>
            <button mat-button [matMenuTriggerFor]="menu">
                <mat-icon mat-button [matMenuTriggerFor]="menu">settings</mat-icon> Opciones
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item href="">
                    <mat-icon>build
                    </mat-icon>Ajustes
                </button>
                <button mat-menu-item href="" (click)="logout()">
                    <mat-icon>exit_to_app
                    </mat-icon>Cerrar Sesi&oacute;n
                </button>
            </mat-menu>
        </div>
    </mat-toolbar-row>
</mat-toolbar>



<div class="container" *ngIf="!buscando && !verDetalle">

    <mat-card class="example-card">
        <mat-card-header>
            <div class="row" style="width: 100%;">
                <div mat-card-avatar class="example-header-image"></div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="title1b">Tótem de consulta</div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subTitle">
                    <p>Dirección de Obras Municipales</p>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>

            <div class="row">

                <div class="rol-div">
                    <h4 class="card-title">Nombre del conjunto</h4>
                    <mat-form-field class="mat-field-rol">
                        <input matInput type="text" placeholder="Nombre" [formControl]="nombre_conjunto">
                        <button mat-button *ngIf="nombre_conjunto.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="nombre_conjunto.setValue('')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

            </div>


            <div class="row">

                <div class="rol-div">
                    <h4 class="card-title">Búsqueda por Rol</h4>
                    <mat-form-field class="mat-field-rol">
                        <input matInput type="text" placeholder="Nº Rol" [formControl]="rol">
                        <button mat-button *ngIf="rol.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="rol.setValue('')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

            </div>

            <div class="row">

                <div class="rol-div">
                    <h4 class="card-title">Búsqueda por Dirección</h4>
                    <mat-form-field class="mat-field-rol">
                        <input matInput type="text" placeholder="Calle" [formControl]="calle">
                        <button mat-button *ngIf="calle.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="calle.setValue('')">
                            <mat-icon>close</mat-icon>
                        </button>

                    </mat-form-field>&nbsp;
                    <mat-form-field class="mat-field-rol">
                        <input matInput type="text" placeholder="Nº Calle" [formControl]="nroCalle">
                        <button mat-button *ngIf="nroCalle.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="nroCalle.setValue('')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="btn-cont">
                    <button class="btn-busqueda" mat-raised-button (click)="buscar()"
                        [disabled]="((!rol.valid && !calle.valid && !nroCalle.valid) && !nombre_conjunto.valid || (calle.valid && !nroCalle.valid) || (!calle.valid && nroCalle.valid) || ((nroCalle.valid || calle.valid) && nombre_conjunto.valid) || (nombre_conjunto.valid && rol.valid) || ((nroCalle.valid || calle.valid) && rol.valid)) ">Búsqueda</button>
                </div>

            </div>

        </mat-card-content>
        <mat-card-actions></mat-card-actions>
    </mat-card>

</div>

<div class="container" *ngIf="buscando && !verDetalle && type == 'conjunto'">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <p align="right">
                <button color="primary" mat-raised-button (click)="volver()">Volver a buscar</button>
            </p>

            <mat-card class="example-card">
                <mat-card-header>
                    <div class="row">
                        <h1 class="text-center">{{dataBusqueda }}</h1>
                        <hr />
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <h4>Conjuntos relacionados con su búsqueda: (click en "Nombre" para detalles)</h4>
                    <div class="row" class="col-md-12">
                        <div class="col-md-6 titleTable">Nombre</div>
                        <div class="col-md-2 titleTable">Tipo</div>
                        <div class="col-md-2 titleTable">Sector</div>
                        <div class="col-md-2 titleTable">Etapa</div>
                    </div>
                    <div class="row col-md-12" *ngFor="let res of resultados; let i = index">
                        <div class="col-md-6 dataTable">
                            <a style="cursor: pointer;" (click)="traerDetalles(i, 'conjunto')">{{
                                res.fieldData.ConjHab_Nombre}}
                            </a>
                        </div>
                        <div class="col-md-2 dataTable">
                            {{ res.fieldData.ConjHab_Tipo}}
                        </div>
                        <div class="col-md-2 dataTable">
                            {{ res.fieldData.ConjHab_Sector_Etapa}}
                        </div>
                        <div class="col-md-2 dataTable">
                            {{ res.fieldData.ConjHab_Etapa}}
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions class="actions" style="display: flex">

                </mat-card-actions>
            </mat-card>

        </div>
    </div>



</div>

<div class="container" *ngIf="buscando && !verDetalle && type == 'predio'">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <p align="right">
                <button color="primary" mat-raised-button (click)="volver()">Volver a buscar</button>
            </p>

            <mat-card class="example-card">
                <mat-card-header>
                    <div class="row">
                        <h1 class="text-center">{{dataBusqueda }}</h1>
                        <hr />
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <h4>Conjuntos relacionados con su búsqueda: (click en {{ type == 'conjunto' ? '"Nombre"': '"Rol"'}}
                        para detalles)</h4>
                    <div class="row" class="col-md-12">
                        <div class="col-md-4 titleTable">Rol</div>
                        <div class="col-md-8 titleTable">Dirección</div>
                    </div>
                    <div class="row col-md-12" *ngFor="let res of resultados; let i = index">
                        <div class="col-md-4 dataTable">
                            <a style="cursor: pointer;" (click)="traerDetalles(i, 'predio')">{{ res.rol}}
                            </a>
                        </div>
                        <div class="col-md-8 dataTable">
                            {{ res.direccion['Calles 4::Calles_Nombre']}}
                            {{res.direccion['Propiedad_Direccion::PD_Num']}}
                            {{res.direccion['Propiedad_Direccion::PD_Tipo_Complem']}}
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions class="actions" style="display: flex">

                </mat-card-actions>
            </mat-card>

        </div>
    </div>



</div>

<div *ngIf="!buscando && verDetalle && type=='conjunto'">
    <p align="right" style="margin: 10px;">
        <button color="primary" mat-raised-button (click)="volver()">Volver a buscar</button>
    </p>
    <hr />
    <app-detalle-totem [detalle]="detalleSeleccionado"></app-detalle-totem>
</div>
<div *ngIf="!buscando && verDetalle && type=='predio'">
    <p align="right" style="margin: 10px;">
        <button color="primary" mat-raised-button (click)="volver()">Volver a buscar</button>
    </p>
    <hr />
    <app-detalle-totem-direccion [detalle]="detalleSeleccionado">
    </app-detalle-totem-direccion>
</div>